import '@gov.wa.lni/application.janitorial-workload-calculator/source/styles/styles.scss';

import interactions from '@gov.wa.lni/application.janitorial-workload-calculator/source/interactions';
import components from '@gov.wa.lni/application.janitorial-workload-calculator/source/components';

import ApplicationMain from '@gov.wa.lni/application.janitorial-workload-calculator/source/application-main.vue';
import store from '@gov.wa.lni/application.janitorial-workload-calculator/source/store.js';

import HomePage from '@gov.wa.lni/application.janitorial-workload-calculator/source/pages/home.page.vue';
import JobPlanPage from '@gov.wa.lni/application.janitorial-workload-calculator/source/pages/job-plan.page.vue';
import JobReportPage from '@gov.wa.lni/application.janitorial-workload-calculator/source/pages/job-report.page.vue';
import ManagementReportPage from '@gov.wa.lni/application.janitorial-workload-calculator/source/pages/management-report.page.vue';
import ErgonomicEvaluationPage from '@gov.wa.lni/application.janitorial-workload-calculator/source/pages/ergonomic-evaluation.page.vue';

const options = {
    addAccessibleRouting: true,
    components: {
        ApplicationMain,
    },
    applicationComponents: [
        ...components,
    ],
    applicationActions: interactions,
};

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
        meta: {
            title: 'Home',
        },
    },
    {
        path: '/job-plan',
        name: 'JobPlanPage',
        component: JobPlanPage,
        meta: {
            title: 'Job Plan',
        },
    },
    {
        path: '/job-report',
        name: 'JobReportPage',
        component: JobReportPage,
        meta: {
            title: 'Job Report',
        },
    },
    {
        path: '/management-report',
        name: 'ManagementReportPage',
        component: ManagementReportPage,
        meta: {
            title: 'Management Report',
        },
    },
    {
        path: '/ergonomic-evaluation',
        name: 'ErgonomicEvaluationPage',
        component: ErgonomicEvaluationPage,
        meta: {
            title: 'Ergonomic Evaluation',
        },
    },
];
options.routing = {
    routes,
    navigationGuards: {
        beforeEach: (store, to, from, next) => {
            if (to.path === '/') {
                next();
                return;
            }
            const isInitialized = !!store.state.appState?.isInitialized;
            if (!isInitialized) {
                next('/');
                return;
            }
            store.commit('appState/SET_VALUE', {
                key: 'isLoading',
                value: true,
            });
            next();
        },
    },
};

window.lni.oneLniCorePlugin.initialize(
    options,
    configuration => {
        window.lni.Vue.use(window.lni.oneLniCorePlugin);
        const application = new window.lni.Vue(configuration);
        window.lni.oneLniCorePlugin.setApplication(application);
        application.$store.registerModule('appState', store);
    });